"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _react = _interopRequireDefault(require("react"));
var _react2 = _interopRequireWildcard(require("@nerdwallet/base-styles/react"));
var _excluded = ["spacing", "children", "className", "style", "component"];
var ContainerImpl = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? {
      top: 0,
      bottom: 0
    } : _ref$spacing,
    children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    component = _ref.component,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(component, (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _react2.mergeStyles)((0, _react2.default)((0, _map2.default)(spacing, function (val, key) {
    return "margin-".concat(key, "-").concat(val);
  })), {
    className: className,
    style: style
  })), otherProps), {}, {
    ref: ref
  }), children);
});
var _default = ContainerImpl;
exports.default = _default;